/* eslint-disable camelcase */
import * as THREE from 'three'
import { seats, textGeometries, materials } from '../utils/mapData'
import { drawTable2Seats } from './drawTable2Seats'
import { drawTableSeats } from './drawTableSeats'
import { COLORS, TIER_COLORS } from '../constants'
import { tierColorObj, colorIndex } from './drawGroupSeats'

export const drawTable = (group, groups, options, circlePartsCount) => {
  const {
    scene,
    scale,
    fonts,
    center_x,
    center_y,
    seat_circle_radius,
    events,
    enableTicketTypeAssign,
    selectedTierId,
    sceneMeshes
  } = options

  const groupObj = new THREE.Group()
  group.x = group.x || 0
  group.y = -group.y || 0
  groupObj.position.set(group.x * scale, group.y * scale, 0)
  scene.add(groupObj)

  const table = group.children[0]

  table.children.forEach((seat, seatIndex) => {
    const tierId = groups[group.id].groups[0].units[seatIndex].tier
    const seatLabelText = groups[group.id].groups[0].units[seatIndex].label
    const seatExternalLink =
      groups[group.id].groups[0].units[seatIndex].external_link

    const faceTo = seatIndex === 0 ? 'left' : 'right'

    if (!tierColorObj[tierId]) {
      tierColorObj[tierId] = TIER_COLORS[colorIndex.value]
      colorIndex.value++
    }

    switch (circlePartsCount) {
      case 2:
        // draw table 2
        drawTable2Seats(seat.id, {
          color: COLORS.AVAILABLE,
          position: [seat.cx * scale, -seat.cy * scale, 0],
          rotation: 0,
          tierId,
          scene,
          center_x,
          center_y,
          scale,
          seat_circle_radius: seat_circle_radius - 2,
          parent: groupObj,
          events,
          sectionLabel: groups[group.id].label,
          rowLabel: groups[group.id].groups[0].label,
          label: seatLabelText,
          fonts,
          type: seat.type,
          faceTo,
          enableTicketTypeAssign,
          tierColor: tierColorObj[tierId],
          selectedTierId,
          sceneMeshes
        })
        break
      default:
        // draw table circle
        drawTableSeats(
          seat.id,
          {
            color: COLORS.AVAILABLE,
            position: [seat.cx * scale, -seat.cy * scale, 0],
            rotation: group.rotation || 0,
            tierId,
            scene,
            center_x,
            center_y,
            scale,
            seat_circle_radius: seat_circle_radius - 2,
            parent: groupObj,
            events,
            sectionLabel: groups[group.id].label,
            rowLabel: groups[group.id].groups[0].label,
            label: seatLabelText,
            fonts,
            type: seat.type,
            isExternalLink: group.isExternalLink,
            seatExternalLink,
            enableTicketTypeAssign,
            tierColor: tierColorObj[tierId],
            selectedTierId,
            sceneMeshes
          },
          seats,
          materials,
          textGeometries,
          group
        )
        break
    }
  })
}
